"use client"
import { ConfigProvider } from "@/hooks/useConfig";
import { ModalProvider } from "@ampol/design-system";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import MsalInstanceProvider from "../Msal/MsalInstanceProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnMount: false,
      retryOnMount: false,
      refetchOnWindowFocus: false,
    },
  },
});
export default function Providers({children}) {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider>
        <ModalProvider>
          <MsalInstanceProvider>{children}</MsalInstanceProvider>
        </ModalProvider>
      </ConfigProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
